$(document).foundation();

jQuery(document).ready(function($) {

  // popup
  if (!Cookies.get('popup_closed')) {
    $('.popup').addClass('popup--is-showing')
  }
  $('.popup-close').on('click', function() {
    Cookies.set('popup_closed', 'true');
    $('.popup').remove()
  })

  // resize background
  $(window).on('resize', function() {
    var windowInnerHeight = window.innerHeight
    var windowInnerWidth = window.innerWidth
    var backgroundImageHeight = windowInnerHeight
    if (Foundation.MediaQuery.current == 'small') {
      backgroundImageHeight -=  $('.strip-bottom').outerHeight()
      backgroundImageHeight -=  $('.strip-top-small').outerHeight()
    } else {
      backgroundImageHeight = windowInnerHeight
    }
    $('.background, .popup').css({ height: windowInnerHeight })
    $('.background-image').removeClass('background-image-portrait').removeClass('background-image-landscape')
    if (windowInnerWidth > windowInnerHeight) {
      $('.background-image').addClass('background-image-landscape')
    } else {
      $('.background-image').addClass('background-image-portrait')
    }
  }).trigger('resize')

  var pageLoading = false
  var $article = $('article')
  var $body = $('body')
  var isLoggedIn = $('body').hasClass('logged-in')

  doBinds()

  $(window).on('popstate', function (event) {
    loadPage(window.location.href)
  })

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  function loadPage(url) {
    $.ajax({
      url: url,
      cache: true,
      dataType: 'html',
      beforeSend: function(xhr) {
        //$('html, body').animate({ scrollTop: 0 }, 500)
        $body.addClass('loading')
        pageLoading = true
      }
    }).done(function(html) {
      $('html, body').animate({ scrollTop: 0 }, 0)
      var articleHtml = $(html).filter('.page').find('article').html()
      var classes = $(html).filter('.page').data('body-class')
      var newPageTitle = $(html).filter('.page').data('page-title')
      $body.removeClass().addClass(classes)
      $article.html(articleHtml)
      $(document).foundation();
      doBinds()
      setTimeout(function() {
        $body.removeClass('loading')
      }, 500)
      pageLoading = false
      document.title = newPageTitle
    }).fail(function(error) {
      alert('Error loading ' + href)
    })

  }

  function doBinds() {

    // fancy load
    $('a[data-state]').off('click').on('click', function(e) {
      if (pageLoading == false && isLoggedIn == false) {
        var url = $(this).attr('href')
        if (url !== window.location.href) {
          history.pushState(null, null, url)
        }
        loadPage(url)
        e.preventDefault()
        e.stopPropagation()
      }
    })

    // load form
    $('.form-container').each(function () {
      var $formContainer = $(this)
      var form_id = $(this).data('form-id')
      $.ajax({
       type : "GET",
       url : "/wp-admin/admin-ajax.php",
       data : {
        action: "simoneleighvenice_gf_button_ajax_get_form",
        form_id: form_id
      },
       success: function(response) {
         $formContainer.html(response);
        }
      });
    })

    // flickity
    $('.block-exhibition-artworks').each(function() {
      var $block = $(this)
      var id = $block.attr('id')
      var $carouselSmall = $block.find('.carousel-small').flickity({
        cellSelector: '.carousel-cell',
        draggable: true,
        setGallerySize: false,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true,
        pauseOnHover: false,
        autoPlay: 0,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 45,
          x2: 60, y2: 40,
          x3: 25
        },
        on: {
          staticClick: function( event, pointer, cellElement, cellIndex ) {
            var modalId = '#modal-exibition-artworks-' + id
            var flickityId = modalId + ' .carousel'
            $(modalId).foundation('open')
            $(flickityId).flickity('select', cellIndex)
          },
          select: function() {
            if ($carouselSmall) {
              // update caption
              var currentIndex = $carouselSmall.data('flickity').selectedIndex
              var $cell = $block.find('.carousel-cell').eq(currentIndex)
              $block.find('.caption-container').html($cell.find('span.caption').html())
            }
          }
        }
      })
    })

    // flickity large artwork slideshow
    $('.reveal-exhibition-artworks').each(function() {
      var $block = $(this)
      var $carouselLarge = $block.find('.carousel-large').flickity({
        cellSelector: '.carousel-cell',
        draggable: true,
        setGallerySize: false,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true,
        pauseOnHover: false,
        autoPlay: 0,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 45,
          x2: 60, y2: 40,
          x3: 25
        },
        on: {
          select: function() {
            if ($carouselLarge) {
              // update caption
              var currentIndex = $carouselLarge.data('flickity').selectedIndex
              var $cell = $block.find('.carousel-cell').eq(currentIndex)
              $block.find('.caption-container').html($cell.find('span.caption').html())
            }
          }
        }
      })
    })

    $(document).on('open.zf.reveal', '[data-reveal]', function () {
      $('.reveal-exhibition-artworks .carousel').flickity('resize')
    })

    // waypoints
    setTimeout(function () {
      $('.fade-move-set').each(function() {
        var offsetAmount = '70%'
        var delayMultiplier = 300
        var delayStart = 0;
        if ($(this).data('offset')) {
          offsetAmount = $(this).data('offset')
        }
        if ($(this).data('delay-multiplier')) {
          delayMultiplier = $(this).data('delay-multiplier')
        }
        if ($(this).data('delay-start')) {
          delayStart = $(this).data('delay-start')
        }
        $(this).waypoint(function(direction) {
          var count = 0
          $(this.element).find('.fade-move-set-item').each(function() {
            var $item = $(this)
            var delay = delayMultiplier * count + delayStart
            setTimeout(function() {
              $item.addClass('fade-move-set-item--moved')
            }, delay)
            count++
          })
          this.destroy()
        }, {
          offset: offsetAmount
        })
      })
    }, 1000);

  }

  $('.menu-toggle').on('click', function(e) {
    $('body').toggleClass('main-menu--is-showing')
    e.preventDefault()
  })

  $('.toggle-back').on('click', function(e) {
    $('body').addClass('page--is-hidden')
    e.preventDefault()
  })

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
